import { httpClient, mountUrl } from '@locaweb/design-system-vue'

const BASE_URL = '/api/v1'
const BASE_URL_SITES = '/api/v1/sites'
const DOMAIN_CHECK = `${BASE_URL_SITES}/domain_check`
const INSTALL = `${BASE_URL}/install`
const CHECK_DOMAIN = `${BASE_URL}/domains/check`
const CHANGE_DOMAIN = `${BASE_URL}/sites/update_wordpress_url`
const METRICS = `${BASE_URL}/metrics`
const SECURITY = `${BASE_URL}/navarch/$id/security`

const findDomainStatus = (domain) => {
  return httpClient.get(DOMAIN_CHECK, { params: { domain } })
}

const findAll = (id) => {
  return httpClient.get(BASE_URL_SITES, {
    params: {
      plan_id: id
    }
  })
}

const postWebsite = (params, id) => {
  httpClient.post(INSTALL, {
    plan_id: id,
    domain: params.domain,
    site_title: params.title,
    email: params.email,
    user: params.user,
    password: params.password,
    repeat_password: params.password
  })
}

const websiteTransfer = (params, id) => {
  httpClient.post(INSTALL, {
    plan_id: id,
    site_title: params.title,
    email: params.email,
    user: params.user,
    password: params.password,
    repeat_password: params.password
  })
}

const findSecurity = async (id) => {
  return httpClient.get(mountUrl(SECURITY, { id }))
}

const updateCdn = async (id, statuscdn, wordpressId) => {
  try {
    await httpClient.put(`${BASE_URL_SITES}/${id}/update_cdn`, {
      cdn: statuscdn,
      wordpress_id: wordpressId
    })
  } catch (error) {
    console.error(error)
  }
}

const enableSecurity = async (wordpressId) => {
  try {
    await httpClient.put(`${BASE_URL}/navarch/${wordpressId}/enable_security`)
  } catch (error) {
    console.error(error)
  }
}

const deleteSite = (id) => {
  return httpClient.delete(`${BASE_URL_SITES}/${id}`)
}

const checkDomain = (domain, id) => {
  return httpClient.get(CHECK_DOMAIN, { params: { domain, id } })
}

const changeDomain = async (site) => {
  try {
    await httpClient.put(
      CHANGE_DOMAIN, site
    )

    if (isAlternativeDomain(this.site.domain) === true) {
      sendTransferenceMetrics('transfer_site_domain_modified',
        site.planId,
        site.wordpressId,
        site.domain,
        site.id)
    }
  } catch (e) {
    console.error('Algo deu errado. Por favor, tente novamente.')
  }
}

const isAlternativeDomain = (domain) => {
  return domain.endsWith(process.env.VUE_APP_WORDPRESS_ALTERNATIVE_DOMAIN)
}

const sendTransferenceMetrics = async (
  measurement, planId, wordpressId = '', domain = '', featureSiteId = '') => {
  try {
    await httpClient.post(METRICS, {
      site: {
        measurement,
        wordpress_id: wordpressId,
        plan_id: planId,
        domain,
        feature_site_id: featureSiteId
      }
    })
  } catch (exception) {
    console.error(`Send metric failed of plan ${planId}!`)
  }
}

const changePassword = async (site, wordpressId) => {
  return httpClient.put(`${BASE_URL}/navarch/${wordpressId}/change_password`, {
    password: site.password,
    user: site.user
  })
    .catch((error) => {
      console.error('Erro ao trocar a senha:', error)
      throw error
    })
}

const findIdWp = (domain) => {
  return httpClient.get(`${BASE_URL}/navarch/${domain}/id`)
}

const findUsers = (wordpressId) => {
  return httpClient.get(`${BASE_URL}/navarch/${wordpressId}/users`)
}

const checkMigration = (planId) => {
  return httpClient.get(`${BASE_URL}/migrations/check/${planId}/`)
}

export {
  findAll,
  findDomainStatus,
  postWebsite,
  changeDomain,
  changePassword,
  checkDomain,
  websiteTransfer,
  deleteSite,
  updateCdn,
  findSecurity,
  enableSecurity,
  findUsers,
  findIdWp,
  checkMigration
}
